import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../../state/reducer/types.tsx';
import {
	getProjectKey,
	isProjectAdmin,
	isProjectSimplified,
} from '../../../state/selector/app-props/index.tsx';
import { isWidgetEnabled } from '../../../state/selector/app-state/index.tsx';
import { getNextGenWidgetSettingsLink, getWidgetSettingsLink } from './constants/index.tsx';
import { WidgetChannelView } from './view.tsx';

const mapStateToProps = (state: State) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const { hostname } = window.location;
	const projectKey = getProjectKey(state);
	const isSimplified = isProjectSimplified(state);
	return {
		isAdmin: isProjectAdmin(state),
		isEnabled: isWidgetEnabled(state),
		link: isSimplified
			? getNextGenWidgetSettingsLink(hostname, projectKey)
			: getWidgetSettingsLink(projectKey),
	};
};

export const WidgetChannel = connect(mapStateToProps, {})(WidgetChannelView);
